import React, { useState, useEffect } from 'react';

import { getConfiguration } from '../../api/config';
import { windowOpen } from '../../api/index';

import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { SignInButton } from './SignInButton';
import Plantilla from '../plantillas/Plantilla';
import { setProgress } from '../Progreso';

/**
 * Renders the login page
 */
export default function Office365Login() {
    useEffect(() => { setProgress(0, 'Inicia tu proceso'); }, []);

    return (<>
        <Container className='home' >
            <Row >
                <Col>
                    <Plantilla id="Login" />
                </Col>
            </Row>
            <Row style={{ marginBlock: "30px" }}>
                <Col>
                    <div className="d-grid gap-2">
                        <SignInButton />
                    </div>
                </Col>
            </Row>
            <Row style={{ textAlign: "left" }}>
                <Col>
                    <RealizarPagoButton />
                </Col>
            </Row>
            <Row style={{ textAlign: "left" }}>
                <Col>
                    <DudasConAccesoButton />
                </Col>
            </Row>
        </Container>
    </>);
};

const RealizarPagoButton = ({ caption }) => {
    const handleOnClick = () => { windowOpen(getConfiguration().portalPagosUrl); };
    caption = (!!caption) ? caption : "Quiero realizar un pago";

    return (<>
        <div className="d-grid gap-2">
            <Button variant='outline-secondary' size='sm' onClick={handleOnClick}>{caption}</Button>
        </div>
    </>);
};

const DudasConAccesoButton = ({ caption }) => {
    const handleOnClick = () => { windowOpen(getConfiguration().dudasConAccesoUrl); };
    caption = (!!caption) ? caption : "Tengo dudas con mi acceso";

    return (<>
        <div className="d-grid gap-2">
            <Button variant='outline-secondary' size='sm' onClick={handleOnClick}>{caption}</Button>
        </div>
    </>);
};
